import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Title } from '../../../../components/presentation/Text'
import Center from '../../../../components/helpers/Center'
import Panel from '../../../../components/structure/Panel'

const SuccessPanel = () => {
  const { t } = useTranslation('import')
  return (
    <Panel flex={12} noMargin>
      <Center>
        <Title size="h5" color={COLORS.dark3}>
          {t('importCompletedSuccessfully')}
        </Title>
      </Center>
    </Panel>
  )
}

export default SuccessPanel
